export default __webpack_public_path__ + "static/media/ImmagineBackground.965af9d2.jpg";